/* NimbleGamer — Rebels Drop | theme.js */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Mobile nav ---------- */
  function toggle(el, on) { if (el) el.classList[on ? 'add' : 'remove']('is-open'); }
  var mNav = $('#MobileNav');
  $$('[data-burger]').forEach(function (b) { b.addEventListener('click', function () { toggle(mNav, true); }); });
  $$('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', function () { toggle(mNav, false); }); });

  /* ---------- Cart drawer ---------- */
  var drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
  function openCart() { toggle(drawer, true); toggle(overlay, true); }
  function closeCart() { toggle(drawer, false); toggle(overlay, false); }
  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (drawer) { e.preventDefault(); openCart(); }
    });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); toggle(mNav, false); } });

  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = ('0' + cart.item_count).slice(-2);
        });
        renderDrawer(cart);
      })
      .catch(function () {});
  }

  function renderDrawer(cart) {
    var body = $('[data-cart-drawer-body]');
    var foot = $('[data-cart-drawer-total]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><p class="display" style="font-size:32px">Bag empty.</p><p>Time to gear up.</p></div>';
      if (foot) foot.textContent = '';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image + '" alt="">' : '<div class="ph" style="width:100%;height:100%"></div>';
      return '<div class="cart-line"><div class="cart-line__media">' + img + '</div>' +
        '<div><div class="cart-line__t">' + it.product_title + '</div>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-line__v">' + it.variant_title + '</div>' : '') +
        '<div class="qty" data-line="' + it.key + '"><button data-qty="-1" aria-label="Decrease">&minus;</button>' +
        '<input type="text" value="' + it.quantity + '" readonly><button data-qty="1" aria-label="Increase">+</button></div></div>' +
        '<div class="cart-line__price">' + fmtMoney(it.final_line_price) +
        '<button class="cart-line__rm" data-remove="' + it.key + '">Remove</button></div></div>';
    }).join('');
    if (foot) foot.innerHTML = '<div class="cart-foot__sum"><span class="note">Subtotal</span><span class="big">' + fmtMoney(cart.total_price) + '</span></div>';
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        renderDrawer(cart);
        $$('[data-cart-count]').forEach(function (el) { el.textContent = ('0' + cart.item_count).slice(-2); });
        if (document.body.classList.contains('template-cart')) location.reload();
      });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-remove]');
    if (rm) { changeLine(rm.getAttribute('data-remove'), 0); return; }
    var q = e.target.closest('[data-qty]');
    if (q) {
      var wrap = q.closest('[data-line]');
      var input = wrap.querySelector('input');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(q.getAttribute('data-qty'), 10));
      changeLine(wrap.getAttribute('data-line'), next);
    }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  $$('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawer) return; /* fall back to page cart */
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { refreshCart(); openCart(); })
        .catch(function () {})
        .then(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } });
    });
  });

  /* ---------- Variant selection ---------- */
  $$('[data-variant-root]').forEach(function (root) {
    var data = JSON.parse(root.getAttribute('data-variants') || '[]');
    var idField = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-variant-price]');
    var btn = root.querySelector('[data-add-btn]');
    function selected() {
      var vals = {};
      $$('input[type=radio]:checked', root).forEach(function (i) {
        var m = i.name.match(/option(\\d)/);
        if (m) vals[m[1]] = i.value;
      });
      return vals;
    }
    function update() {
      var v = selected();
      var match = data.find(function (x) {
        return (!v['1'] || x.option1 === v['1']) &&
               (!v['2'] || x.option2 === v['2']) &&
               (!v['3'] || x.option3 === v['3']);
      });
      if (!match) match = data[0];
      if (!match) return;
      if (idField) idField.value = match.id;
      if (priceEl) priceEl.textContent = fmtMoney(match.price);
      if (btn) {
        btn.disabled = !match.available;
        btn.textContent = match.available ? (btn.getAttribute('data-label') || 'Add to bag') : 'Sold out';
      }
    }
    $$('input[type=radio]', root).forEach(function (i) { i.addEventListener('change', update); });
    update();
  });

  /* ---------- Gallery carousel ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    var slides = $$('.gallery__slide', g);
    var dots = $$('[data-gallery-dot]', g);
    var i = 0;
    function go(n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, x) { d.setAttribute('aria-current', x === i ? 'true' : 'false'); });
    }
    var prev = g.querySelector('[data-gallery-prev]');
    var next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, x) { d.addEventListener('click', function () { go(x); }); });
  });

  /* ---------- Accordion ---------- */
  $$('[data-accordion-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
    });
  });

  /* ---------- Marquee: duplicate for seamless loop ---------- */
  $$('[data-marquee-track]').forEach(function (track) {
    track.innerHTML = track.innerHTML + track.innerHTML;
  });

  /* keep cart count fresh on load */
  if (drawer) refreshCart();
})();
